import React, { useEffect, useState } from "react";
import { useSelector,useDispatch} from "react-redux";
import VIcon from "components/custom/Icon";
import { themeIcons } from "config/theme";
import { stringIsNullOrEmpty } from '../../util/Util'
import "../../assets/css/bannerapk.css"
import { useLocation } from 'react-router-dom';
import {
  WebUrl,
} from "../../util/Constant";
import { useTranslation } from "react-i18next";
import { HIDE_APK_BANNER_DURATION } from "../../util/Constant";
import { showResponseMessage } from "redux/AppAction";

const BannerAPKMobile = () => {
  
  const [shouldShowBannerAPK, setShouldShowBannerAPK] = useState(false);
  const [clickCloseBannerAPK, setClickCloseBannerAPK] = useState(false);
  const [bannerAPKUrl,setBannerAPKUrl]=useState("");
  const [bannerAPKIcon, setBannerAPKIcon]=useState("");

  const bannerAPK=useSelector((state)=>state.appState.bannerAPK);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  var { t } = useTranslation();
  var brandName = useSelector((state) => state.appState.brandName);
  var _dispatch = useDispatch();



	useEffect(() => {
    
	init();
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

	}, []);

  useEffect(() => {
    // Only update bannerAPKIcon if the URL actually changed
    if(bannerAPK && bannerAPK["apkIcon"] && bannerAPK["apkIcon"] !== bannerAPKIcon) {
      //console.log("mobile image changed from:", bannerAPKIcon, "to:", bannerAPK["apkIcon"])
      setBannerAPKIcon(bannerAPK["apkIcon"]);
    } else {
      //console.log("mobile image unchanged:", bannerAPKIcon)
    }
  }, [bannerAPK]);





  async function init() {

    let bannerAPKIcon=bannerAPK;
    
    if(bannerAPKIcon){
    if(!stringIsNullOrEmpty(bannerAPKIcon?.desktopImage) && isValidApkUrl(bannerAPKIcon?.url)){

      setBannerAPKUrl(bannerAPKIcon.url);
      
      if(!clickCloseBannerAPK){
        setShouldShowBannerAPK(true);
      }

    }else{
      setShouldShowBannerAPK(false);
    } 
    }else{
      setShouldShowBannerAPK(false);
    }
  }

  function isValidApkUrl(url) {
    try {
      if(stringIsNullOrEmpty(url)) return false;
      const parsedUrl = new URL(url);
      return ["http:", "https:"].includes(parsedUrl.protocol);
    } catch (e) {
      return false;
    }
  }

  const FILE_EXTENSIONS = [".apk", ".xapk", ".zip", ".exe", ".msi", ".dmg", ".pkg"];

  const getFileNameFromUrl = (url) => {
    try {
      const pathname = new URL(url).pathname;
      return decodeURIComponent(pathname.substring(pathname.lastIndexOf("/") + 1)) || "download";
    } catch {
      return "download";
    }
  };

  const openInNewTab = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const triggerDownload = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAPK = async () => {
    if (!bannerAPKUrl) return;
    let bannerApkDownload=bannerAPK?.apkDownload;

    try {

       if (!bannerApkDownload) {
      openInNewTab(bannerAPKUrl);
      return;
      }

      const pathname = new URL(bannerAPKUrl).pathname.toLowerCase();
      const hasFileExt = FILE_EXTENSIONS.some((ext) => pathname.endsWith(ext));

      if (hasFileExt) {
        triggerDownload(bannerAPKUrl, getFileNameFromUrl(bannerAPKUrl));
        return;
      }

      let shouldDownload = false;

      try {
        const response = await fetch(bannerAPKUrl, {
          method: "HEAD",
          redirect: "follow"
        });

        if (response.ok) {
          const contentType = (response.headers.get("content-type") || "").toLowerCase();
          const contentDisposition = (response.headers.get("content-disposition") || "").toLowerCase();

          if (
            contentDisposition.includes("attachment") ||
            contentType.includes("application/vnd.android.package-archive") ||
            contentType.includes("application/octet-stream")
          ) {
            shouldDownload = true;
          }
        }
      } catch {
        // HEAD can fail due to CORS, fallback to open link.
      }

      if (shouldDownload) {
        triggerDownload(bannerAPKUrl, getFileNameFromUrl(bannerAPKUrl));
      } else {
        openInNewTab(bannerAPKUrl);
      }
    } catch {
      _dispatch(showResponseMessage(false, t("DOWNLOAD_APK_ERROR")));
    }
  };

 const CloseBtn = (props)=> (
    <button className="close-button" onClick={(e) => {      
        e.stopPropagation();
        setShouldShowBannerAPK(false);
        setClickCloseBannerAPK(true);

        // Expire after 7 days
        localStorage.setItem('hideApkBanner', JSON.stringify({ expiry: Date.now() + HIDE_APK_BANNER_DURATION }));
      }}>
    <VIcon icon={themeIcons.close} className="img" />
    </button>
    
  );

	return (
    <>
      {shouldShowBannerAPK && location.pathname !== "/"+ WebUrl.getCurrentLocale() +"/livechat" && !window.isWebView && (
        <>
            <div className="mobile-apk-banner" id="mobileApkBanner">
              <div className="banner-left">
                <div>
                  <img
                    src={bannerAPKIcon}
                    className="img"
                    alt="apk-icon"
                    key={bannerAPKIcon}
                  />
                </div>
                <div>
                <div className="txt-top">{t("APK_UP_LBL", { brandName })}</div>
                <div className="txt-btm">{t("APK_BTM_LBL")}</div>
              </div>
            </div>
        
            <div
                className="download-button"
                onClick={handleDownloadAPK}
            >
                <div>
                  <VIcon
                    icon={themeIcons.download}
                    className="img"
                  />
                </div>
                <div className="text">{t("DOWNLOAD")}</div>
                </div>
            <CloseBtn />
            </div>
          </>
      )}
    </>
	);
};

export default BannerAPKMobile;
